import React from "react";
import { Button, Toast } from "antd-mobile";
import { post } from "../../../utils/request";
import { href } from "../../../utils/util";
import api from "./api";
import { loadingToast } from "../loading";
import Cookies from "js-cookie";

import "./index.less";

class PapersUploadGR extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            zheng: "",
            fan: "",
            zhengUrl: "",
            fanUrl: "",
            name: "",
            cerificationNo: "",
            caType: "MOBILE",
            defaultData: {
                front: "",
            },
        };
    }

    componentWillReceiveProps(prevProps) {
        if (prevProps.fangShi !== this.state.caType) {
            this.setState({
                caType: prevProps.fangShi,
            });
        }
        if (
            this.state.defaultData.front !== prevProps.defaultData.front &&
            prevProps.defaultData.front
        ) {
            this.setState(
                {
                    defaultData: prevProps.defaultData,
                    zhengUrl: prevProps.defaultData.front,
                    zheng: "111111111",
                    fanUrl: prevProps.defaultData.back,
                    fan: "11111111",
                },
                () => {
                    // this.imgOCR();
                }
            );
        }
    }

    // 自动识别证件
    imgOCR = () => {
        const { urlOps } = this.props;
        let _this = this;
        // console.log(api.ocrIDCard)
        if (this.state.zheng && this.state.fan) {
            loadingToast("身份证OCR识别中...");
            post({
                url: api.h5.ocrIDCard + "?app_stoken=" + urlOps.app_stoken,
                headers: {
                    "Content-Type": "application/json",
                },
                data: {
                    // identityImage: this.state.zheng,
                    // identityBackImage: this.state.fan,
                    identityImage: this.state.zhengUrl,
                    identityBackImage: this.state.fanUrl,
                },
            }).then(
                (res) => {
                    console.log("身份证OCR识别", res);
                    // Toast.info(res.msg,1);
                    Toast.hide();
                    if (res.result === "success") {
                        _this.setState(
                            {
                                name: res.data.realName,
                                cerificationNo: res.data.idcardNum,
                            },
                            () => {
                                // _this.onCancel();
                                _this.props.onCancel(
                                    res.data.idcardNum,
                                    res.data.realName,
                                    this.state.zhengUrl,
                                    this.state.fanUrl
                                );
                            }
                        );
                    } else {
                        if (res.code == "-1") {
                            Toast.info("登录失效", 1);
                        } else {
                            Toast.info("身份证OCR识别失败", 1);
                        }
                    }
                },
                (res) => {
                    console.log("身份证OCR识别失败", res);
                    if (res.code == "-1") {
                        Toast.info("登录失效", 1);
                    } else {
                        Toast.info("身份证OCR识别失败", 1);
                    }
                }
            );
        }
    };
    imgUpload = (file, FN) => {
        const { urlOps } = this.props;
        loadingToast("图片上传中...");
        post({
            url: api.attachment + "?app_stoken=" + urlOps.app_stoken,
            headers: {
                "Content-Type": "multipart/form-data;",
            },
            data: {
                attachmenType: "IMGS_ALL",
                file: [file],
            },
        }).then(
            (res) => {
                if (res.result === "success" && res.data) {
                    // console.log(res.data)
                    FN(res.data[0].attachmenturl);
                } else {
                    if (res.code == "-1") {
                        Toast.info("登录失效", 1);
                    } else {
                        Toast.info(res.msg, 1);
                    }
                }
            },
            (res) => {
                if (res.code == "-1") {
                    Toast.info("登录失效", 1);
                } else {
                    Toast.info(res.msg, 1);
                }
            }
        );
    };
    imgChange = (type) => {
        let _this = this;
        var reader = new FileReader();
        var fan = document.getElementById("fan").files;
        var zheng = document.getElementById("zheng").files;
        if (type === 1) {
            if (zheng[0].size > 10485760) {
                //10*1024*1024 = 10485760
                Toast.info("证件照片不能大于10M", 1);
                return;
            }
            reader.readAsDataURL(zheng[0]);
            reader.onload = function (e) {
                // console.log(this.result)
                _this.imgUpload(zheng[0], (img) => {
                    _this.setState(
                        {
                            zhengUrl: img,
                            zheng: this.result.split("base64,")[1],
                        },
                        () => {
                            Toast.hide();
                            _this.imgOCR();
                        }
                    );
                });
            };
        } else {
            if (fan[0].size > 10485760) {
                Toast.info("证件照片不能大于10M", 1);
                return;
            }
            reader.readAsDataURL(fan[0]);
            reader.onload = function () {
                // console.log(this.result)
                _this.imgUpload(fan[0], (img) => {
                    _this.setState(
                        {
                            fanUrl: img,
                            fan: this.result.split("base64,")[1],
                        },
                        () => {
                            Toast.hide();
                            _this.imgOCR();
                        }
                    );
                });
            };
        }
    };

    onCancel = () => {
        let { zhengUrl, fanUrl } = this.state;
        var name = document.getElementById("name").value;
        var cerificationNo = document.getElementById("cerificationNo").value;
        this.props.onCancel(cerificationNo, name, zhengUrl, fanUrl);
    };

    render() {
        return (
            <div className="PapersUploadGRBox">
                <div className="uploadImgBox">
                    <div className="uploadImg zheng">
                        <input
                            id="zheng"
                            type="file"
                            accept="image/*"
                            onChange={() => {
                                this.imgChange(1);
                            }}
                        />
                        <label
                            htmlFor="zheng"
                            style={{
                                backgroundImage: this.state.zheng
                                    ? "url(" + this.state.zhengUrl + ")"
                                    : "",
                                backgroundSize: "contain",
                            }}
                        ></label>
                        <span>身份证人像面</span>
                    </div>
                    <div className="uploadImg fan">
                        <input
                            id="fan"
                            type="file"
                            accept="image/*"
                            onChange={() => {
                                this.imgChange(2);
                            }}
                        />
                        <label
                            htmlFor="fan"
                            style={{
                                backgroundImage: this.state.fan
                                    ? "url(" + this.state.fanUrl + ")"
                                    : "",
                                backgroundSize: "contain",
                            }}
                        ></label>
                        <span>身份证国徽面</span>
                    </div>
                </div>
                <div className="toastText">
                    *请上传清晰的身份证原件正、反面照片，系统将自动识别证件信息。图片仅限jpeg、jpg、png格式且大小不超过3M。，个人身份信息将用于申请数字证书。
                </div>
                {this.state.zheng ? (
                    <div className="numberBox">
                        <p>
                            以下信息自动识别，需仔细核对，如识别有误，请修正。
                        </p>
                        <div>
                            <label htmlFor="name">
                                {this.props.selectSign &&
                                this.state.caType !== "AUTH" ? (
                                    <span>{this.props.selectSign}姓名</span>
                                ) : (
                                    ""
                                )}
                                {this.props.selectSign &&
                                this.state.caType === "AUTH" ? (
                                    <span>经办人姓名</span>
                                ) : (
                                    ""
                                )}
                                {!this.props.selectSign ? (
                                    <span>姓名</span>
                                ) : (
                                    ""
                                )}
                                <input
                                    id="name"
                                    value={this.props.name}
                                    onChange={(e) => {
                                        this.onCancel();
                                    }}
                                    onBlur={() => {
                                        this.onCancel();
                                    }}
                                />
                            </label>
                            <label htmlFor="cerificationNo">
                                {this.props.selectSign &&
                                this.state.caType !== "AUTH" ? (
                                    <span>{this.props.selectSign}身份证号</span>
                                ) : (
                                    ""
                                )}
                                {this.props.selectSign &&
                                this.state.caType === "AUTH" ? (
                                    <span>经办人身份证号</span>
                                ) : (
                                    ""
                                )}
                                {!this.props.selectSign ? (
                                    <span>身份证号</span>
                                ) : (
                                    ""
                                )}
                                <input
                                    id="cerificationNo"
                                    value={this.props.cerificationNo}
                                    onChange={(e) => {
                                        this.onCancel();
                                    }}
                                    onBlur={() => {
                                        this.onCancel();
                                    }}
                                />
                            </label>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default PapersUploadGR;



// WEBPACK FOOTER //
// ./src/identityVerification/modules/papersUpload_GR/index.js